import {OrderContentService} from "../../../../services/orderContentService";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot} from "@angular/router";
import {BaseResponse} from "../../../../objects/common/baseResponse";
import {OrderContent} from "../../../../objects/orders/orderContent";
/**
 * Created by alex.y on 10/4/2017.
 */

@Injectable()
export class OrderContentResolver{

    constructor(public orderContentService: OrderContentService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<BaseResponse<Array<OrderContent>>> {
        let orderId = route.params["id"];

        if (orderId)
            return this.orderContentService.getByOrderIdAndStatus(orderId);

        return null;
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/orderContentResolver.ts